import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { showSuccess, showError } from "utils/notifications";

const useLogout = (message = true,) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const logout = async () => {
    const accessToken = localStorage.getItem("accessToken");
    const refreshToken = localStorage.getItem("refreshToken");

    try {
      // 🔐 Call backend logout (optional but recommended)
      if (accessToken && refreshToken) {
        await axios.post(
          `${process.env.REACT_APP_BASE_URL}/auth/logout`,
          {
            refreshToken: refreshToken || "",
          },
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
      } else {
        console.warn("No tokens found, skipping backend logout");
      }
    } catch (err) {
      console.warn("Logout API call failed:", err);
      showError("Logout failed. Please try again.");
    } finally {
      // 🧹 Always clear client state
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("user");

      dispatch({ type: "REMOVE_TOKEN" });
      dispatch({ type: "LOGOUT_USER" });
      dispatch({ type: "REMOVE_MENUACCESS" });
      dispatch({ type: "REMOVE_MENULIST" });

      if (message) {
        showSuccess("Logout successful.");
      }

      navigate("/signin", { replace: true });
    }
  };

  return logout;
};

export default useLogout;